import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { match } from 'ts-pattern'

import RecapExtensionWorkerPage from '@/components/pages/guest/_recap-ext-worker/containers/recap-ext-worker-page'
import { useFilters } from '@/components/pages/guest/_recap-ext-worker/state/filters-atom'
import { searchParamsExtWorkerSchema } from '@/components/pages/guest/_recap-ext-worker/types'

export const Route = createFileRoute('/_guest/guest/recap-extentions-worker')({
  component: RouteComponent,
  validateSearch: searchParamsExtWorkerSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  useEffect(() => {
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.province_code, search.city_code])

  return (
    <RecapExtensionWorkerPage
      activeTab={search.tab}
      onTabChange={tab => {
        const onChange = match(tab)
          .with('national', () => filters.reset)
          .with('province', () => filters.onProvinceChange)
          .with('city', () => filters.onCityChange)
          .otherwise(() => filters.reset)

        const code = match(tab)
          .with('province', () => search.province_code ?? '')
          .with('city', () => search.city_code ?? '')
          .otherwise(() => '')

        onChange(code)
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
